module.exports = __webpack_public_path__ + "static/media/CC-COL11_1PuA1qjP2maVZuAXU-R8_a1_c-Lkki03A.5a22d65a.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/CC-COL11_1PuA1qjP2maVZuAXU-R8_a1_c-Lkki03A
// module id = 589
// module chunks = 0